import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const STATUS_CONFIG = {
  blocked: { label: 'Bloqueado', bg: '#FFEBEE', border: '#FFCDD2', dot: '#E53935', text: '#C62828' },
  expired: { label: 'Expirado', bg: '#F5F5F5', border: '#E0E0E0', dot: '#9E9E9E', text: '#616161' },
};

/**
 * BlockedIpStatusBadge - Indicador de situação do bloqueio de IP (Admin Geral > Segurança)
 * @param {Object} props
 * @param {boolean} props.isBlocked
 */
function BlockedIpStatusBadge({ isBlocked }) {
  const cfg = isBlocked ? STATUS_CONFIG.blocked : STATUS_CONFIG.expired;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.6,
        px: 1.25,
        py: 0.4,
        borderRadius: '20px',
        backgroundColor: cfg.bg,
        border: `1px solid ${cfg.border}`,
        width: 'fit-content',
      }}
    >
      <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: cfg.dot, flexShrink: 0 }} />
      <Typography
        variant="caption"
        sx={{ fontWeight: 500, fontSize: '0.75rem', lineHeight: 1, color: cfg.text, whiteSpace: 'nowrap' }}
      >
        {cfg.label}
      </Typography>
    </Box>
  );
}

export default BlockedIpStatusBadge;
